<template>
<div class="app-wrapper">
  <!-- 判断是否登录 -->
  <template v-if="isLogin">
    <layout>
      <router-view />
    </layout>
  </template>
  <!-- 未登录显示登录页面 -->
  <template v-else>
    <login />
  </template>
</div>
</template>

<script>
import Layout from "layout";
import Login from "views/login/index.vue";
import { reactive, toRefs, watch } from 'vue';
import { useRouter } from "vue-router";
export default {
  components: {
    Layout,
    Login,
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      isLogin: false
    });

    // 监听当前路由
    watch(() => router.currentRoute.value, (newValue) => {
      let researcherInfo = JSON.parse(sessionStorage.getItem("researcherInfo"));
      // 如果是普通页面
      if (newValue.path != "/login") {
        // 判断是否是登陆状态
        if (researcherInfo) {
          state.isLogin = true;
        } else {
          state.isLogin = false;
        }
      } else {
        state.isLogin = false;
      }
    }, { immediate: true })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss">

.el-overlay {
  z-index: 3000 !important;
}

.app-wrapper {
  height: 100%;

  #page {
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: block;
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(14, 22, 37, 0.5);
    }
  }
}
</style>
